export const baseGetTaskAttributeOptions = (fields: string[]) => `
  query TaskAttributeOptions($id: Int!) {
    taskAttributeOption(taskAttributeId: $id) {
      label: optionName
      value: optionName
      ${fields.join('\n')}
    }
  }
`;

export const getTaskAttributeOptions = baseGetTaskAttributeOptions([]);

export const getTaskAttributesWithFields = (fields: string[]) => baseGetTaskAttributeOptions(fields);

export interface GetTaskAttributeOptionsType {
  taskAttributeOption: Array<{
    label: string;
    value: string;
    isDefault?: boolean;
  }>;
}
